import { APP_ENV } from '@/lib/env';

// Plain-text build marker pinned to the bottom-left so it's easy to confirm
// which build is live. Hidden outside staging.
export function BuildBadge() {
  if (APP_ENV !== 'staging') return null;

  const sha = typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : 'dev';
  const builtAt = typeof __BUILT_AT__ !== 'undefined' ? __BUILT_AT__ : '';
  const builtAtShort = builtAt ? builtAt.slice(0, 16).replace('T', ' ') + 'Z' : '';
  const tag = typeof __BUILD_TAG__ !== 'undefined' ? __BUILD_TAG__ : '';
  const separator = ' \u00b7 ';

  return (
    <div
      role="status"
      aria-label={`Build ${sha}`}
      className="pointer-events-none fixed bottom-2 left-2 z-9999 font-mono text-2xs text-text-tertiary select-none"
    >
      staging{separator}{sha.slice(0, 7)}
      {tag && `${separator}${tag}`}
      {builtAtShort && `${separator}${builtAtShort}`}
    </div>
  );
}
